/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonBlue from "../../components/Button/ButtonBlue";
import {
  hideSharepost,
  showShareto,
  fillList,
  emptyList,
} from "../../redux/actions/sharePost";

import Cancel from "../../common/images/cancel.png";
import "../../styles/shared.styles.scss";
import SharePostCard from "./SharePostCard";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { ButtonCommonTopNew } from "../Theme";
import { FaSearch } from "react-icons/fa";
import { CgArrowLongRight } from "react-icons/cg";
import { FaArrowRight } from "react-icons/fa";
import { list } from "postcss";

function SharePost(props) {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.showsharepost.show);

  const [List, setList] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [myPosts, setMyPosts] = useState([]);
  const [textFilter, setTextFilter] = useState("");

  useEffect(() => {
    axios.get(serverUrl.Reflections).then((resp) => {
      if (resp.status === 200) {
        setMyPosts(resp.data.results);
      }
    });
  }, []);

  useEffect(() => {
    if (show) {
      setList([]);
    }
  }, [show]);

  useEffect(() => {
    const filteredData = myPosts.filter((postItem) =>
      postItem.reflection_title.toLowerCase().includes(textFilter.toLowerCase())
    );

    setFilteredPosts(filteredData);
  }, [textFilter, myPosts]);

  function addItem(id) {
    setList((prev) => {
      const exists = prev.some((p) => p.reflection_id === id);
      if (exists) {
        // remove
        const updated = prev.filter((p) => p.reflection_id !== id);
        return updated;
      } else {
        // add
        const newItems = myPosts.filter((item) => item.reflection_id === id);
        const updated = [...prev, ...newItems];
        return updated;
      }
    });
  }

  function removeItem(id) {
    const newList = List.filter((item) => item.reflection_id !== id);
    setList(newList);
  }

  function close() {
    dispatch(hideSharepost());
    dispatch(emptyList());
  }

  function ShareTo() {
    dispatch(hideSharepost());
    dispatch(showShareto());
    dispatch(fillList(List));
  }

  return show ? (
    // <div className="flex justify-center items-center fixed top-0 left-0 z-50 w-full h-full bg-black bg-opacity-30">
    //   <Card className="w-3/4 lg:w-1/2 rounded-lg overflow-hidden">
    //     <div className="relative flex py-6">
    //       <div className="w-full font-bold flex justify-center items-center">
    //         Share Post
    //       </div>
    //       <div className="absolute right-5" onClick={close}>
    //         <img src={Cancel} className="w-5 h-5 opacity-30 cursor-pointer" />
    //       </div>
    //     </div>
    //     <hr />
    <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
      <div
        className={`relative cardBackgroundColor rounded-xl shadow-md p-4 px-6 max-w-full max-h-screen overflow-auto  w-full md:w-4/5 popUpWidth`}
      >
        <div className="flex gap-2 pt-2 items-center justify-between pb-2">
          <p className="font-semibold blackColor">Share Post</p>
          <button
            onClick={close}
            className="text-gray-600 hover:text-black text-xl font-bold"
          >
            &times;
          </button>
        </div>
        <div className="flex flex-row items-center relative">
          <input
            className="h-9 w-full text-sm bg-white borderf-1 px-2 pr-9 lg:pr-9 blackColor rounded-md"
            type="search"
            placeholder="Type to Search..."
            onChange={(e) => setTextFilter(e.target.value)}
            value={textFilter}
          />
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
            <FaSearch className="secondaryIcon" />
          </div>
        </div>
        <div className="overflow-y-scroll sharepost flex flex-col my-3 gap-3 pr-4">
          {filteredPosts.map((item, idx) => (
            <SharePostCard
              item={item}
              idx={idx}
              add={addItem}
              remove={removeItem}
              isShow={List.some(
                (item1) => item1.reflection_id === item.reflection_id
              )}
            />
          ))}
        </div>
        <div className="w-full flex justify-center">
          <ButtonCommonTopNew
            title=""
            className={`px-5 border p-2 flex gap-2 items-center text-sm rounded-lg ${
              List.length <= 0
                ? "pointer-events-none opacity-40"
                : "cursor-pointer"
            }`}
            onClick={List.length > 0 ? ShareTo : null}
          >
            Share To <FaArrowRight className="primaryIcon" />
          </ButtonCommonTopNew>
          {/* <ButtonBlue title={"SHARE TO"} onClick={List.length > 0 ? ShareTo : null} /> */}
        </div>
      </div>
    </div>
  ) : null;
}

export default SharePost;
